module.exports = __webpack_public_path__ + "img/document-reject-1.6afdbf51.svg";